export const DEFAULT_ORG_CODE = 'ORG01';
